import React, { useEffect, useState, Fragment } from "react";
import Layout from "../Components/Reuseable/layout";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import Cookies from "js-cookie";
import { Accordion } from "react-bootstrap";
import "../../Webiste/Components/CSS/pagesCSS/dashboard.css";
import ScrollContainer from "react-indiana-drag-scroll";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import Select from "react-select";
import Pagination from "./Pagination";
import "../Components/CSS/RaceCardCSS/racecard.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchHorseStats } from "../redux/getReducer/getHorseStats";
import { fetchHorseRecord } from "../redux/getReducer/getHorseRecord";
import Moment from "react-moment";
import { IoIosArrowDropdownCircle, IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowRight } from "react-icons/md";
import PleaseWait from "../Components/Reuseable/PleaseWait";
import arrow1 from "../assets/image 13 (Traced).png";
import { truncateRaceType, formatDateStandard, toTitleCase } from "../service/stringUtils";

import { fetchResultYearFilterForStats } from "../redux/getStatsFilterReduce/getResultYearFilterForStats";
import { fetchRaceTypeFilterForStats } from "../redux/getStatsFilterReduce/getRaceTypeFilterForStats";
import { fetchTrackLengthFilterForStats } from "../redux/getStatsFilterReduce/getTrackLengthFilterForStats";
import { fetchHorseKindFilterForStats } from "../redux/getStatsFilterReduce/getHorseKindFilterForStats";
import { fetchRaceKindFilterForStats } from "../redux/getStatsFilterReduce/getRaceKindFilterForStats";
import { fetchRaceNationalityFilterForStats } from "../redux/getStatsFilterReduce/getRaceNationalityFilterForStats";
import { fetchRaceCourseFilterForStats } from "../redux/getStatsFilterReduce/getRaceCourseFilterForStats";
import { fetchDatesFilterForStats } from "../redux/getStatsFilterReduce/getDatesFilterForStats";
import { fetchGroundTypeFilterForStats } from "../redux/getStatsFilterReduce/getGroundTypeFilterForStats";

import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import HorseModal from "../Components/Modal/HorseModal";
import JockeyModal from "../Components/Modal/JockeyModal";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import VideoFrame from "../Components/Modal/VideoFrame";
import RaceModal from "../Components/Modal/RaceModal";
import { DatePicker } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

export default function Horsestatistics() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  // SELECTORS
  const { data: horsestats, status } = useSelector((state) => state.horsestats);
  const { data: horserecord, statusdata } = useSelector((state) => state.horserecord);
  const { data: ResultYearFilterForStats } = useSelector((state) => state.ResultYearFilterForStats);
  const { data: RaceTypeFilterForStats } = useSelector((state) => state.RaceTypeFilterForStats);
  const { data: TrackLengthFilterForStats } = useSelector((state) => state.TrackLengthFilterForStats);
  const { data: HorseKindFilterForStats } = useSelector((state) => state.HorseKindFilterForStats);
  const { data: RaceKindFilterForStats } = useSelector((state) => state.RaceKindFilterForStats);
  const { data: RaceNationalityFilterForStats } = useSelector((state) => state.RaceNationalityFilterForStats);
  const { data: RaceCourseFilterForStats } = useSelector((state) => state.RaceCourseFilterForStats);
  const { data: GroundTypeFilterForStats } = useSelector((state) => state.GroundTypeFilterForStats);

  // FILTER STATES
  const [ResultYearData, setResultYearData] = useState("");
  const [ResultRaceCourseData, setResultRaceCourse] = useState("");
  const [ResultNationalityData, setResultNationality] = useState("");
  const [ResultRaceTracklengthData, setResultRaceTracklength] = useState("");
  const [ResultGroundData, setResultGround] = useState("");
  const [ResultRaceKindData, setResultRaceKind] = useState("");
  const [ResultHorseKindData, setResultHorseKind] = useState("");
  const [ResultRaceTypeData, setResultRaceType] = useState("");
  const [StartDate, setStartDate] = useState(moment().subtract(179, "days").format("YYYY-MM-DD"));
  const [EndDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  // DERIVED VARIABLES
  let year = ResultYearData?.id;
  let Nationality = ResultNationalityData?.id;
  let RaceCourse = ResultRaceCourseData?.id;
  let GroundType = ResultGroundData?.id;
  let RaceKind = ResultRaceKindData?.id;
  let HorseKind = ResultHorseKindData?.id;
  let RaceType = ResultRaceTypeData?.id;
  let TrackLength = ResultRaceTracklengthData?.id;

  let RaceCourseSearch = RaceCourse || "";
  let HorseKindSearch = HorseKind || "";
  let TrackLengthSearch = TrackLength || "";
  let RaceTypeSearch = RaceType || "";
  let RaceKindSearch = RaceKind || "";
  let RaceNationalitySearch = Nationality || "";
  let RaceGroundSearch = GroundType || "";

  // PAGINATION & UI
  const [compIndex, setCompIndex] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(11);
  let totalcountdata = horsestats ? horsestats.totalcount : "";
  let totalpagesdata = horsestats ? horsestats.totalPages : "";

  // MODAL STATES
  const [show, setShow] = useState(false);
  const [modaldata, setmodaldata] = useState();
  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };

  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => { setmodaldatas(data); await setShows(true); };

  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };

  const [showJockey, setShowJockey] = useState(false);
  const [modaldataJockey, setmodaldataJockey] = useState();
  const handleCloseJockey = () => setShowJockey(false);
  const handleShowJockey = (data) => { const id = data?._id || data; if (id) navigate("/jockey-detail?" + id); };

  const handleDateChange = (dates, dateStrings) => {
    if (!dates || !dateStrings) {
      setStartDate("");
      setEndDate("");
      return;
    }
    setStartDate(dateStrings[0]);
    setEndDate(dateStrings[1]);
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // EFFECTS
  // useEffect(() => {
  //   const selectedYear = ResultYearData?.id;
  //   if (!selectedYear) {
  //     setStartDate(moment().subtract(179, "days").format("YYYY-MM-DD"));
  //     setEndDate(moment().format("YYYY-MM-DD"));
  //     return;
  //   }

  //   const startOfYear = moment(`${selectedYear}-01-01`, "YYYY-MM-DD");
  //   const endOfYear = moment(`${selectedYear}-12-31`, "YYYY-MM-DD");
  //   const today = moment();

  //   let start = startOfYear;
  //   let end = endOfYear.isAfter(today, "day") ? today : endOfYear;

  //   // If someone picks a year fully in the future, keep a valid range.
  //   if (end.isBefore(start, "day")) start = end.clone();

  //   setStartDate(start.format("YYYY-MM-DD"));
  //   setEndDate(end.format("YYYY-MM-DD"));
  // }, [ResultYearData]);

  useEffect(() => {
    dispatch(fetchHorseStats({ StartDate, EndDate, RaceCourseSearch, HorseKindSearch, TrackLengthSearch, RaceTypeSearch, RaceKindSearch, RaceGroundSearch, RaceNationalitySearch, currentPage }));
  }, [dispatch, StartDate, EndDate, RaceCourseSearch, HorseKindSearch, TrackLengthSearch, RaceTypeSearch, RaceKindSearch, RaceGroundSearch, RaceNationalitySearch, currentPage]);

  useEffect(() => {
    // dispatch(fetchResultYearFilterForStats({ year, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceTypeFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchTrackLengthFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchHorseKindFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceKindFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceNationalityFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceCourseFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    // dispatch(fetchDatesFilterForStats({ year, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchGroundTypeFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
  }, [dispatch, StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength]);

  const handleTrainerRecord = async (horseId, index) => {
    setCompIndex(index);
    const id = horseId?._id || horseId;
    await dispatch(fetchHorseRecord({ id, StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
  };

  function distanceLabel(distance, rank) {
    const DistanceTobeChecked = parseFloat(distance);
    if (DistanceTobeChecked.toFixed(2) > 25) return "Dist";
    else if (DistanceTobeChecked.toFixed(2) == 0.05 && rank < 80) return "SHd";
    else if (DistanceTobeChecked.toFixed(2) == 0.1 && rank < 80) return "Hd";
    else if (DistanceTobeChecked.toFixed(2) == 0.25 && rank < 80) return "Nk";
    else if (DistanceTobeChecked.toFixed(2) == 0.01 && rank < 80) return "Ns";
    else if (DistanceTobeChecked.toFixed(2) == 0.0 && rank < 80) return rank === 1 ? 0 : "Dh";
    else return distance;
  }

  // DROPDOWNS
  let RaceYearDropdown = ResultYearFilterForStats.map(item => ({ id: item.RacesYear, value: item.RacesYear, label: item.RacesYear }));
  let NationalityDropdown = RaceNationalityFilterForStats?.map(item => ({ id: item?.NationalityDataRaceCourse?._id, value: cookiedata === "en" ? item?.NationalityDataRaceCourse?.NameEn : item?.NationalityDataRaceCourse?.NameAr, label: cookiedata === "en" ? item?.NationalityDataRaceCourse?.NameEn : item?.NationalityDataRaceCourse?.NameAr }));
  let RaceCourseDropdown = RaceCourseFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.TrackNameEn : item.TrackNameAr, label: cookiedata === "en" ? item.TrackNameEn : item.TrackNameAr }));
  let GroundTypeDropdown = GroundTypeFilterForStats?.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let RaceTypeDropdown = RaceTypeFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let TrackLengthDropdown = TrackLengthFilterForStats.map(item => ({ id: item._id, value: item.TrackLength, label: item.TrackLength }));
  let HorseKindDropdown = HorseKindFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let RaceKindDropdown = RaceKindFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#0c1a3e',
      border: 'none',
      borderRadius: '8px',
      minHeight: '44px',
      color: 'white',
      marginBottom: '0',
      cursor: 'pointer',
      boxShadow: 'none'
    }),
    singleValue: (provided) => ({ ...provided, color: 'white' }),
    placeholder: (provided) => ({ ...provided, color: '#9da7be', fontSize: '13px' }),
    dropdownIndicator: (provided) => ({ ...provided, color: 'white' }),
    indicatorSeparator: () => ({ display: 'none' }),
    clearIndicator: (provided) => ({ ...provided, color: '#fff', padding: '0 8px' }),
    valueContainer: (provided) => ({ ...provided, padding: '2px 8px', overflow: 'hidden' }),
    input: (provided) => ({ ...provided, margin: 0, padding: 0, opacity: 0 }),
    menu: (provided) => ({ ...provided, backgroundColor: '#0c1a3e', zIndex: 9999 }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isFocused ? '#2173d1' : '#0c1a3e', color: 'white', fontSize: '13px', cursor: 'pointer' })
  };

  return (
    <Fragment>
      <div className="horse-stats-responsive-wrapper">
        <div className="new-horse-stats-page-wrapper">
          <div className="common-page-banner"><h1>{t("Horse Statistics")}</h1></div>
          <div className="new-horse-main-card-container">
            <div className="new-horse-filter-section-card">
              <div className="new-horse-dropdown-flex-row">
                <div className="new-horse-range-item">
                  <style>{`.horse-stats-responsive-wrapper .new-horse-custom-range-picker input::placeholder { color: #9da7be !important; -webkit-text-fill-color: #9da7be !important; opacity: 1 !important; }`}</style>
                  <RangePicker
                    value={[
                      StartDate ? dayjs(StartDate, "YYYY-MM-DD") : null,
                      EndDate ? dayjs(EndDate, "YYYY-MM-DD") : null,
                    ]}
                    onChange={handleDateChange}
                    format="YYYY-MM-DD"
                    className="new-horse-custom-range-picker"
                    placeholder={[t("Start Date"), t("End Date")]}
                    separator={<span style={{ color: '#9da7be' }}>To</span>}
                    allowClear
                  />
                </div>
                <Select styles={customSelectStyles} placeholder={t("Nationality")} options={NationalityDropdown} onChange={setResultNationality} className="new-horse-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Race course")} options={RaceCourseDropdown} onChange={setResultRaceCourse} className="new-horse-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Ground Type")} options={GroundTypeDropdown} onChange={setResultGround} className="new-horse-flex-item" isClearable />
              </div>
              <div className="new-horse-search-date-row">
                <Select styles={customSelectStyles} placeholder={t("Race Kind")} options={RaceKindDropdown} onChange={setResultRaceKind} className="new-horse-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("KindOfHorse")} options={HorseKindDropdown} onChange={setResultHorseKind} className="new-horse-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Track length")} options={TrackLengthDropdown} onChange={setResultRaceTracklength} className="new-horse-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Race Type")} options={RaceTypeDropdown} onChange={setResultRaceType} className="new-horse-flex-item" isClearable />
              </div>
            </div>

            <div className="new-horse-stats-table-box">
              {status === "idle" ? (
                <>
                  <div className="table-x-scroll-wrapper">
                    <div className="new-horse-main-thead">
                      <div>{t("HorseName")}</div><div>{t("Runs")}</div><div>{t("Wins")}</div><div>{t("Second")}</div><div>{t("Third")}</div><div>{t("Fourth")}</div><div>{t("Fifth")}</div><div>{t("Earning")}</div><div>{t("Wins")}%</div><div>{t("Place")}%</div><div></div>
                    </div>
                    {horsestats?.data?.map((item, i) => (
                      <Accordion key={i} className="new-horse-stats-accordion-wrapper">
                        <Accordion.Item eventKey={i} className="new-horse-acc-item" onClick={() => handleTrainerRecord(item.HorseID, i)}>
                          <Accordion.Header className="new-horse-acc-header-custom">
                            <div className="new-horse-acc-header-grid">
                              <div className="new-horse-td-main-link" onClick={(e) => { e.stopPropagation(); handleShow(item.HorseID); }}>
                                {cookiedata === "en" ? window.textTransform(item.HorseIDData?.NameEn) : item.HorseIDData?.NameAr}
                              </div>
                               <div>{item.HorseIDData?.Runs}</div><div>{item.HorseIDData?.wins}</div><div>{item.HorseIDData?.second}</div><div>{item.HorseIDData?.third}</div><div>{item.HorseIDData?.fourth}</div><div>{item.HorseIDData?.fifth}</div><div className="new-horse-bold-text">{t("AED")} {Number(item.HorseIDData?.earning || 0).toLocaleString()}</div><div>{Number(item.HorseIDData?.winspercentage || 0).toFixed(2)}</div><div>{Number(item.HorseIDData?.placespercentage || 0).toFixed(2)}</div><div style={{ textAlign: 'right' }}><MdKeyboardArrowRight className="new-horse-acc-arrow-icon" /></div>
                            </div>
                          </Accordion.Header>
                          {compIndex === i && (
                            <Accordion.Body style={{ padding: 0 }}>
                              <ScrollContainer>
                                <div className="new-horse-inner-grid-table">
                                   <div className="new-horse-inner-grid-header">
                                     <div>{t("Date")}</div><div>{t("Race No")}</div><div>{t("Crs")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("Speed")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("W Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div></div>
                                   </div>
                                  <div className="new-horse-inner-grid-body">
                                    {statusdata === "loading" ? <div className="new-horse-loader-inner"><Lottie animationData={Animate} style={{ width: '60px' }} /></div> : !horserecord || horserecord.length === 0 ? <div className="new-horse-no-history">{t("No History Yet")}</div> : (
                                      horserecord.map((subItem, idx) => {
                                        const groundName = subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                                        return (
                                          <div key={idx} className={`new-horse-inner-card-row ${groundName === "Dirt" ? 'row-dirt' : groundName === "Turf" ? 'row-turf' : 'row-default'}`}>
                                            <div onClick={() => handleShowRace(subItem.RaceID)} className="new-horse-link-text">{formatDateStandard(subItem.RaceResultData?.Day)}</div>
                                            <div>{subItem.RaceNumber || "-"}</div>
                                            <div>{cookiedata === "en" ? subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.RaceCourseData?.AbbrevEn : subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.RaceCourseData?.AbbrevAr} ({cookiedata === "en" ? groundName?.charAt(0) : subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameAr?.charAt(0)})</div>
                                            <div>{subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.TrackLengthData?.TrackLength}</div>
                                            <div>
                                              {cookiedata === "en" 
                                                ? toTitleCase(truncateRaceType(subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.RaceTypeModelData?.NameEn)) 
                                                : subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.RaceTypeModelData?.NameAr}
                                            </div>
                                            <div>{subItem.RaceTime}</div>
                                            <div onClick={() => handleShowJockey(subItem.JockeyOnRaceDataResult?._id)} className="new-horse-link-text">
                                              {cookiedata === "en" ? toTitleCase(subItem.JockeyOnRaceDataResult?.NameEn) : subItem.JockeyOnRaceDataResult?.NameAr}
                                            </div>
                                            <div>{subItem.RaceResultData?.RacehorsesData[0]?.JockeyRaceWeight || 0}</div>
                                            <div>{typeof subItem.Speed === "number" ? subItem.Speed.toFixed(2) : "-"}</div>
                                            <div>{subItem.FinalPositionDataHorse === null ? "" : (cookiedata === "en" ? subItem.FinalPositionDataHorse.NameEn : subItem.FinalPositionDataHorse.NameAr)}</div>
                                            <div>{distanceLabel(subItem.Distance, subItem.FinalPositionDataHorse?.Rank)}</div>
                                            <div>{subItem.Runners}</div>
                                            <div onClick={() => handleShow(subItem?.BeatenByData)} className="new-horse-link-text">
                                              {subItem.BeatenByData === null 
                                                ? (cookiedata === "en" ? toTitleCase(subItem.HorseIDData?.HorseBeatenByEnglishName) : subItem.HorseIDData?.HorseBeatenByArabicName) 
                                                : (cookiedata === "en" ? toTitleCase(subItem.BeatenByData?.NameEn) : subItem.BeatenByData?.NameAr)}
                                            </div>
                                            <div>{subItem.BeatenByData ? subItem.BeatenByData?.WinningHorseJockeyWeight : (subItem.HorseIDData?.BeatenByJockeyWeight || 0)}</div>
                                            <div>{subItem.RaceResultData?.RacehorsesData[0]?.HorseNo || "-"}</div>
                                            <div>{subItem.Rating || 0}</div>
                                                                                         <div className="my-new-play-btn" onClick={() => handleShows(subItem.VideoLink)}>
                                               <IoMdPlay />
                                             </div>
                                          </div>
                                        );
                                      })
                                    )}
                                  </div>
                                </div>
                              </ScrollContainer>
                            </Accordion.Body>
                          )}
                        </Accordion.Item>
                      </Accordion>
                    ))}
                  </div>
                  <div className="new-horse-pagination-container"><Pagination postsPerPage={postsPerPage} totalPosts={totalcountdata} paginate={paginate} currentPage={currentPage} TotalPages={totalpagesdata} /></div>
                </>
              ) : <div className="new-horse-loader-main"><Lottie animationData={Animate} className="load1" style={{ marginTop: "30px" }} /></div>}
            </div>
          </div>

          {/* MODALS */}

          <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
          <Modal show={showJockey} onHide={handleCloseJockey} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><JockeyModal data={modaldataJockey} /></Modal.Body></Modal>
          <Modal show={showRace} onHide={handleCloseRace} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><RaceModal id={modaldataRace} /></Modal.Body></Modal>

          <Footer /><CoptRight />
        </div>
      </div>
    </Fragment>
  );
}